import React from 'react'

export default class Jumbotrons extends React.Component {
  render() {
    return (
      <div className="jumbotron">
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/bootstrap/Jumbotron.js